import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_ID,
    mandatorySignIn: true,
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
});
